import { render, staticRenderFns } from "./EmployeeSickWidget.vue?vue&type=template&id=3787e93a&"
import script from "./EmployeeSickWidget.vue?vue&type=script&lang=js&"
export * from "./EmployeeSickWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3787e93a')) {
      api.createRecord('3787e93a', component.options)
    } else {
      api.reload('3787e93a', component.options)
    }
    module.hot.accept("./EmployeeSickWidget.vue?vue&type=template&id=3787e93a&", function () {
      api.rerender('3787e93a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/responsible/planing/widgets/EmployeeSickWidget.vue"
export default component.exports